export default __webpack_public_path__ + "media/images/svg/left-dog-08cc67b20b0efe1e7cee0fb24a1623f5.svg";